import React from 'react'
import AppModal from '../common/AppModal'
import CreateOrUpdateCustomerForm from '../../forms/CreateOrUpdateCustomerForm'

interface CreateCustomerModalProps {
  open: boolean
  onClose: () => void
  loading: boolean
  error: string | null
}

const CreateCustomerModal: React.FC<CreateCustomerModalProps> = ({
  open,
  onClose,
  loading,
  error
}) => (
  <AppModal open={open} onClose={onClose} title="Add New Customer" width="sm" loading={loading}>
    <CreateOrUpdateCustomerForm loading={loading} error={error} />
  </AppModal>
)
export default CreateCustomerModal
